import { useCallback, useEffect, useState } from "react";
import { Search, Building2, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

const Badge = ({ status }) => {
  const map = { completed: "bg-emerald-500/15 text-emerald-400", in_progress: "bg-amber-500/15 text-amber-400" };
  const label = status === "completed" ? "Completed" : status === "in_progress" ? "In progress" : "Not started";
  return <span className={`text-[10px] px-2 py-0.5 rounded-full ${map[status] || "bg-white/5 text-[#71717A]"}`}>{label}</span>;
};

export default function AdminBusinesses() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [denied, setDenied] = useState(false);

  const load = useCallback(() => {
    api.get("/admin/businesses").then((r) => setRows(r.data.businesses))
      .catch((e) => { if (e.response?.status === 403) setDenied(true); })
      .finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  const filtered = rows.filter((r) => {
    const t = q.trim().toLowerCase();
    return !t || r.owner_email.toLowerCase().includes(t) || r.business_name.toLowerCase().includes(t) || r.state.toLowerCase().includes(t);
  });

  if (denied) return <p className="text-sm text-[#71717A]" data-testid="admin-businesses-denied">You don't have the "business.view" permission.</p>;
  if (loading) return <div className="flex justify-center py-20 text-[#71717A]"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div data-testid="admin-businesses">
      <div className="flex items-center gap-2 mb-4"><Building2 className="w-5 h-5 text-[#D4AF37]" /><h3 className="text-white font-medium">Businesses</h3><span className="text-xs text-[#52525B]">({filtered.length})</span></div>
      <div className="relative mb-4 max-w-sm">
        <Search className="w-4 h-4 text-[#71717A] absolute left-3 top-1/2 -translate-y-1/2" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by business, owner, state…" data-testid="admin-business-search" className="bg-[#121214] border-white/10 text-white pl-9 h-10" />
      </div>
      <div className="rounded-2xl border border-white/8 bg-[#121214] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-businesses-table">
            <thead><tr className="border-b border-white/8 text-left text-[#71717A]">
              <th className="px-5 py-3 font-normal">Business</th><th className="px-5 py-3 font-normal">Owner</th>
              <th className="px-5 py-3 font-normal">State</th><th className="px-5 py-3 font-normal">Formation</th>
              <th className="px-5 py-3 font-normal">Credit</th><th className="px-5 py-3 font-normal">Funding</th>
            </tr></thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.user_id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]" data-testid="admin-business-row">
                  <td className="px-5 py-3 text-white">{r.business_name}</td>
                  <td className="px-5 py-3 text-[#A1A1AA]">{r.owner_email}</td>
                  <td className="px-5 py-3 text-[#A1A1AA]">{r.state}</td>
                  <td className="px-5 py-3"><Badge status={r.formation_status} /></td>
                  <td className="px-5 py-3"><Badge status={r.credit_status} /></td>
                  <td className="px-5 py-3"><Badge status={r.funding_status} /></td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={6} className="px-5 py-8 text-center text-[#71717A]">No businesses found.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
